import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

const styles = theme => ({
    formControl: {
        width: '100%'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});

class AvoirClientDialogContent extends React.Component {

    state = {
        commentaire: "",
        numeroPiece: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action} = this.props;

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: "NUMERO_PIECE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Numéro de pièce",
                position: 0,
                valeurString: newState.numeroPiece
            }]
        };

        if (newState.commentaire) {

            let detail = {
                code: "COMMENTAIRE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { commentaire, numeroPiece } = this.state;

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    id="numeroPiece"
                    name="numeroPiece"
                    label="Numéro de pièce (Avoir sur dépôt 01 sans décote)"
                    placeholder="Numéro de pièce"
                    multiline
                    margin="normal"
                    value={numeroPiece}
                    onChange={this.handleChange}
                />

                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />
            </DialogContent>
        );
    }
}

AvoirClientDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(AvoirClientDialogContent);